<template>
    <div>
        <a-button class="mb10" type="primary" @click="$refs.editDiscussModalRef.showFun()">{{$t('program.speak_config_add'/*新增*/)}} </a-button>
        <a-spin :spinning="loading">
            <!--  表格  -->
            <a-table
                ref="table"
                :rowKey="record => record.id"
                :columns="columns"
                :data-source="dataSource">
                <template slot="status" slot-scope="text, record">
                    <a-switch @change="handleChangeStatus(record)" :checked="record.is_show == 1" :checked-children="$t('program.open'/*开启*/ )" :un-checked-children="$t('program.close'/*关闭*/ )" />
                </template>
                <template slot="action" slot-scope="text, record">
                    <a @click="handleEdit(record)">
                        <!--    编辑   -->
                        {{$t('layout.edit')}}
                    </a>
                    <a-divider type="vertical" />
                    <a class="del-button" @click="deleteType(record.id, index)">
                        <!--    删除   -->
                        {{$t('layout.delete')}}
                    </a>
                </template>
            </a-table>
        </a-spin>
        <edit-discuss-modal ref="editDiscussModalRef" @reset="getProgramFayanList"></edit-discuss-modal>
    </div>
</template>
<script>
import editDiscussModal from './components/edit-discuss-modal.vue'
export default {
    name: 'speakConfig',
    components: {
        editDiscussModal
    },
    data() {
        return {
            dataSource: [],
            columns: [
                {
                    title: this.$t('program.chinese_name'/*中文名称*/),
                    dataIndex: 'typename_cn',
                    align: 'left',
                    fixed: 'left',
                    width: 200
                },
                {
                    title: this.$t('program.english_name'/*英文名称*/),
                    dataIndex: 'typename_en',
                    align: 'left',
                    width: 200
                },
                {
                    title: this.$t('program.status'/*状态*/),
                    dataIndex: 'is_show',
                    scopedSlots: { customRender: 'status' },
                    align: 'left',
                },
                {
                    title: this.$t('program.role'/*角色*/),
                    dataIndex: 'juese',
                    align: 'left',
                },
                {
                    title: this.$t('web.actions'/*操作*/),
                    dataIndex: 'action',
                    scopedSlots: { customRender: 'action' },
                    align: 'center'
                }
            ],
            loading: false
        };
    },
    methods: {
        /**
         * ## 获取发言类型列表
         */
        getProgramFayanList() {
            this.$request.get({ url: 'getProgramFayanList', data: { type: 4 } }).then(res => {
                const { code, data, message } = res;
                if (code == 200) {
                    this.dataSource = data
                }
            });
        },
        deleteType (cid, index) {
            this.$confirm({
                title: this.$t('web.tips'/*提示*/),
                content: this.$t('program.confirm_delete_category'/*确定要删除该类别吗？*/),
                okText: this.$t('web.ok'/*确定*/),
                cancelText: this.$t('web.cancel'/*取消*/),
                onOk: () => {
                    this.$request.post({ url: 'deleteType', data: { cid } }).then(res => {
                        this.$message.success(this.$t('authority.delete_success'/*删除成功*/));
                        this.dataSource.splice(index, 1)
                    });
                }
            });
        },
        handleChangeStatus(item) {
            let status = item.is_show == 1 ? 0 : 1;
            let data = {
                category_id: item.id,
                is_show: status,
                juese: item.juese,
                typename_cn: item.typename_cn,
                typename_en: item.typename_en,
                type: item.type
            }
            this.$request.post({ url: 'editCategory', data }).then(res => {
                this.getProgramFayanList();
            });
        },
        handleEdit (item) {
            this.$refs.editDiscussModalRef.showFun(item)
        }
    },
    mounted() {
        this.getProgramFayanList();
    }
};
</script>